import { LandingContext } from 'common/contexts/Landing/Landing'
import { useIntersection, useResolution } from 'common/hooks'
import { Styled } from 'components/Styled'
import { baseURL } from 'models'
import { GeneralMenu } from 'modules/GeneralMenu'
import { useContext, useRef } from 'react'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'react-i18next'
import {
  AboutContainer,
  BookContainer,
  Container,
  ContantContainer,
  LeftImage,
} from './styled'
import { TextContent } from './TextContent'

export const General = () => {
  const { t } = useTranslation()
  const { landing } = useContext(LandingContext)
  const { isMinScreen1000 } = useResolution()
  const ref = useRef(null)
  const isInteract = useIntersection({ element: ref })

  return (
    <>
      <Container>
        <Fade
          direction="up"
          triggerOnce
          delay={500}
          cascade
          style={{ opacity: isInteract ? '1' : '0' }}>
          <Styled.H2 ref={ref}>{t('title.about.us')}</Styled.H2>
          <ContantContainer>
            {/* left */}
            <BookContainer>
              <LeftImage
                src={`${baseURL}/${landing?.headerPhoto}`}
                alt="image restaurant"
              />
              {!isMinScreen1000 && <TextContent />}
            </BookContainer>

            {/* right */}
            <AboutContainer>
              {isMinScreen1000 && <TextContent />}
              <GeneralMenu
                hideOurMenu
                style={{ flexDirection: 'row-reverse', flexWrap: 'wrap' }}
              />
            </AboutContainer>
          </ContantContainer>
        </Fade>
      </Container>
    </>
  )
}
